"use client";

import Input from "@client/components/formik/input";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import Fieldset from "@ui/js/components/form/fieldset";
import { Tile } from "@ui/js/components/tiles/tile";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "loan-application-history";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function LoanApplicationHistory() {
	const { setFieldValue } = useFormikContext();
	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend="Have you recently applied for a loan and either been declined or approved for an amount smaller than what you need?">
			<Input
				type="hidden"
				name="FIELD_NAME_SELECTOR"
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__Yes`,
				)}
				iconLeft={<FontAwesomeIcon icon={faThumbsUp} className="text-lg" />}
				label="Yes"
				value="Yes"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__No`,
				)}
				iconLeft={<FontAwesomeIcon icon={faThumbsDown} className="text-lg" />}
				label="No"
				value="No"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
